import React,{useEffect} from 'react'
import { withRouter } from 'react-router-dom';
import {Box, Text} from 'grommet';
import {NavigationSnackBar} from '../../components/utils/shared/shared'
import { ShipmentSuccessNotification } from '../../components/utils/shared/shipmentViewFunctions';


function ShipmentDangerousGoods(props) {
  const [dgTip, setDgTip] = React.useState(true)
  useEffect(() => {
    setTimeout(() => {
        setDgTip(undefined);
    }, 5000)
  },[]);
  return (
      <Box>
        <NavigationSnackBar title={'Shipment Unsuccuessful'} user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'},{name: 'Create Shipment', link: '/shipments/new'}]}  />
        {dgTip && (<ShipmentSuccessNotification label={"Dangerous Goods Sent"} edit={false} />)}
        <Box direction='column' justify="center" margin='small'>
            <Text>Dangeours Goods Sent</Text>
        </Box>
    </Box>
  )
}

export default withRouter(ShipmentDangerousGoods)
